<table mat-table [dataSource]="data" class="mt-l">

  @for (col of columns; track col.key; let first = $first) {
    <ng-container [matColumnDef]="col.key">

      <th mat-header-cell *matHeaderCellDef [class.mat-column-right]="!first" class="text-bold">
        {{ col.label }}
      </th>

      <td mat-cell *matCellDef="let row" [class.mat-column-right]="!first">
        @switch (col.type) {
          @case ('currency') { {{ row[col.key] | currency:'EUR':'symbol':'1.2-2' }} }
          @case ('number')   { {{ row[col.key] | number:'1.0-0' }} }
          @case ('percent')  { {{ row[col.key] | percent:'1.2-2' }} }
          @default           { {{ row[col.key] }} }
        }
      </td>

      @if (sumRow) {
        <td mat-footer-cell *matFooterCellDef [class.mat-column-right]="!first">
          @if (first) {
            <strong class="text-dhb">{{ sumRow.label }}</strong>
          } @else if (sumRow.values[col.key] !== undefined) {
            @switch (col.type) {
              @case ('currency') { <strong class="text-dhb">{{ sumRow.values[col.key] | currency:'EUR':'symbol':'1.2-2' }}</strong> }
              @case ('number')   { <strong class="text-dhb">{{ sumRow.values[col.key] | number:'1.0-0' }}</strong> }
              @default           { <strong class="text-dhb">{{ sumRow.values[col.key] }}</strong> }
            }
          }
        </td>
      }
    </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="columnKeys"></tr>
  <tr mat-row *matRowDef="let row; columns: columnKeys" [class]="row._rowClass"></tr>

  @if (sumRow) {
    <tr mat-footer-row *matFooterRowDef="columnKeys" class="sum-row"></tr>
  }

</table>
